import {
    Divider,
    Paper
} from "@mui/material";
import { useEffect } from "react";
import { User } from "../../../../types/User";
import LinkedAccounts from "./LinkedAccounts";
import ProfileCompleteness from "./ProfileCompleteness";
import ContactInfo from "./ContactInfo";
import JobTitle from "./JobTitle";
import JobLookingFor from "./JobLookingFor";
import CVUpload from "../CVUpload";

interface LeftSidebarProps {
    userData: User;
    setUserData: React.Dispatch<React.SetStateAction<User | null>>;
    editMode: boolean;
}

const LeftSidebarComponent = ({
    userData,
    setUserData,
    editMode
}: LeftSidebarProps) => {
    const handleChange = (field: string, value: any) => {
        setUserData((prevData) => {
            if (!prevData) return null;
            return {
                ...prevData,
                [field]: value
            };
        });
    };

    return (
        <Paper sx={{ padding: 2, mb: 3, borderRadius: 2 }}>
            <JobTitle
                userData={userData}
                handleChange={handleChange}
                editMode={editMode}
            />
            <CustomDivider />
            <CVUpload
                userData={userData}
                setUserData={setUserData}
                editMode={editMode}
            />
            <CustomDivider />
            <ContactInfo
                userData={userData}
                handleChange={handleChange}
                editMode={editMode}
            />
            <CustomDivider />
            <JobLookingFor
                userData={userData}
                handleChange={handleChange}
                editMode={editMode}
            />
            <CustomDivider />
            <ProfileCompleteness user={userData} />
            <CustomDivider />
            {/* <LinkedAccounts /> */}


        </Paper>
    );
};

const CustomDivider = () => <Divider sx={{ mt: 2, mb: 3 }} />;

export default LeftSidebarComponent; 